module.exports = __webpack_public_path__ + "img/background-3-transparent.3d812ef.png";